import { WorkScheduleUnit, WorkScheduleUnitDetails } from '../../../types/availability';
import { Stringable } from '../Stringable';
import collect from 'collect.js';

export type ScheduleGroupItem = {
  day: number;
  entries: string;
};

export class WorkScheduleHelpers {
  public static groupByDay(schedule: WorkScheduleUnit[]): ScheduleGroupItem[] {
    const grouped = collect(schedule).mapToGroups((item: WorkScheduleUnit) => [
      item.open.day,
      item,
    ]);

    return grouped
      .keys()
      .map((day) => ({
        day,
        entries: collect(grouped.get(day))
          .map((item: WorkScheduleUnit) => WorkScheduleHelpers.stringifyUnit(item))
          .implode(', '),
      }))
      .toArray();
  }

  public static stringifyUnit(unit: WorkScheduleUnit): string {
    return `${WorkScheduleHelpers.stringifyUnitDetails(unit.open)} - ${WorkScheduleHelpers.stringifyUnitDetails(unit.close)}`;
  }

  public static stringifyUnitDetails(value: WorkScheduleUnitDetails): string {
    return `${WorkScheduleHelpers.padTimeUnit(value.hour)}:${WorkScheduleHelpers.padTimeUnit(value.minute)}`;
  }

  private static padTimeUnit(value: number): string {
    return new Stringable(value.toString()).padLeft(2, '0').toString();
  }
}
